import React, { Fragment, useState } from "react";
import CustomModal from "../../CustomModal/CustomModal";
import {
  ChevronDownIcon,
  PencilSquareIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";

const ExternalCourseContextAwareToggle = ({
  children,
  expandableIndex,
  expandableId,
  editValue,
  setExpanded,
  handleEditButtonClick,
  handleDeleteButtonClick,
}) => {
  // state to open edit modal
  const [openEditLectureModal, setOpenEditLectureModal] = useState(false);
  // lecture name state
  const [newName, setNewName] = useState(editValue);
  // edit lecture name
  const handleSave = () => {
    handleEditButtonClick(expandableIndex, newName);
    handleClose();
  };

  // delete a lecture
  const deleteButtonClick = () => {
    handleDeleteButtonClick(expandableIndex);
    handleClose();
  };

  const handleClose = () => {
    setOpenEditLectureModal(false);
  };

  return (
    <Fragment>
      <div className="flex items-center justify-between">
        <h5 className="mb-0">
          <span
            className="align-middle p-1"
            onClick={() =>
              setExpanded((prev) =>
                prev.id === expandableId
                  ? { id: null, index: null }
                  : {
                      id: expandableId,
                      index: expandableIndex,
                    }
              )
            }
          >
            {children}
          </span>
        </h5>
        <div className="flex items-center space-x-2">
          <PencilSquareIcon
            className="text-gray-400 h-3 w-3 cursor-pointer"
            onClick={() => setOpenEditLectureModal(true)}
          />

          <TrashIcon
            className="text-gray-400 h-3 w-3 cursor-pointer"
            onClick={deleteButtonClick}
          />

          <ChevronDownIcon
            className="text-gray-400 h-3 w-3 cursor-pointer"
            onClick={() =>
              setExpanded((prev) =>
                prev.id === expandableId
                  ? { id: null, index: null }
                  : {
                      id: expandableId,
                      index: expandableIndex,
                    }
              )
            }
          />
        </div>
      </div>

      <CustomModal
        show={openEditLectureModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        {openEditLectureModal && (
          <>
            <div className="flex items-center justify-between border-b w-full py-4">
              <h4 className="text-base font-inter font-medium text-black pl-5">
                Edit
              </h4>
              <XCircleIcon
                className="text-gray-400 h-6 w-6 mr-4 cursor-pointer"
                onClick={handleClose}
              />
            </div>
            <div className="w-full flex flex-col px-6 pt-5 pb-2">
              <div className="mb-3">
                <input
                  type="text"
                  placeholder="Enter text here"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  className="px-4 py-2 outline-none border border-gray19 rounded-tl-md rounded-bl-md text-sm font-inter font-medium placeholder:text-gray20 text-gray18 w-full"
                />
              </div>
            </div>
            <div className="w-full flex items-center space-x-4 px-6 pb-5">
              <button
                className="bg-purple1 px-4 py-2 text-white text-sm font-inter font-medium rounded-md"
                onClick={handleSave}
              >
                Save
              </button>
              <button
                className="bg-white px-4 py-2 text-black/70 text-sm font-inter font-medium rounded-md border-gray22 border"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </>
        )}
      </CustomModal>
    </Fragment>
  );
};

export default ExternalCourseContextAwareToggle;
